var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 39a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm8.222-1.692l5.144 5.14a1 1 0 0 1-1.414 1.414l-5.19-5.186A10.953 10.953 0 0 1 30 41c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11c0 2.805-1.05 5.365-2.778 7.308z"
  })));
};
export default SvgSearch;